import { GetUserProjectsQuery } from '@pypestream/api-services';

export type UserProject =
  | GetUserProjectsQuery['tenancy_users'][number]['user_accounts'][number]['user_account_projects'][number]['project']
  | GetUserProjectsQuery['tenancy_users'][number]['_user_teams'][number]['team']['team_accounts'][number]['team_account_projects'][number]['project'];

export const extractUserProjects = (
  data?: GetUserProjectsQuery['tenancy_users'][number]
): UserProject[] => {
  const allProjects: UserProject[] = [];

  data?.user_accounts.forEach((userAccount) => {
    userAccount.user_account_projects.forEach((userAccountProject) => {
      if (userAccountProject.project) {
        allProjects.push(userAccountProject.project);
      }
    });
  });

  data?._user_teams.forEach((userTeam) => {
    userTeam.team.team_accounts.forEach((teamAccount) => {
      teamAccount.team_account_projects.forEach((teamAccountProject) => {
        if (teamAccountProject.project) {
          allProjects.push(teamAccountProject.project);
        }
      });
    });
  });

  const uniqueProjects = Array.from(
    new Map(allProjects.map((p) => [p.id, p])).values()
  );

  return uniqueProjects.filter((project) =>
    project.project_product_settings.some(
      (setting) => setting.product.name === 'PRO_STUDIO'
    )
  );
};
